import { AbstractService } from "./abstract.service";

export class OrdersService extends AbstractService {
  static get entity() {
    return "proxy-gateway/gw-core/order";
  }

  static get entityOrder() {
    return "nsh/odm/api/order/so"
  }
  
  static get entityOrderReturn() {
    return "nsh/odm/api/order/ro"
  }

  static get entityOrderStore() {
    return "nsh/odm/api/order/store"
  }

  static get entityOrderDLO() {
    return "nsh/odm/api/order/dlo"
  }

  static get entityOrderDLO360() {
    return "n360/inte/api/dlo/order"
  }
  
  static get entityOrderDelivery() {
    return "nsh/odm/api/order/dlo"
  }



  static async getOrderById(orderId) {
    try {
      const response = await this.callApi().get(`${this.entityOrder}/${orderId}`);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async getShipperOrderReport(param) {
    try {
      const response = await this.callApi().post(`${this.entityOrderDelivery}/shipper-report`, param);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async updateOrders(order) {
    try {
      const response = await this.callApi().patch(
        `${this.entity}/processor/${order.id}`,
        order
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async getCountItem(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/count-search`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
  
  static async getListItem(params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrder}/search`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
  
  static async updateChangeStatus(itemId, _params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/${itemId}/change-status`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
 
  static async pushOutcomeItem(itemId, _params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/processor/${itemId}/push-outcome`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async creatOrder(params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrder}/new-create-order`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error)
    }
  }

  static async paymentRequest(params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrder}/create-payment`,
        params
      );
      return response.data;
    } catch (error) {
      throw this.errorWrapper(error)
    }
  }

  static async updateOrder(param) {
    try {
      const response = await this.callApi().put(
        `${this.entityOrder}/new-update-order`,
        param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async recordPayment(param) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrder}/record-pay-success`,
        param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async removePayment(param) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrder}/remove-payment-info`,
        param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async cancelItem(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrder}/cancel`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  //V2
  static async getListItemV2(params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrder}/paging-search`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async getListOrdersReturn(params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderReturn}/paging-search`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async getDetailOrdersReturn(id) {
    try {
      const response = await this.callApi().get(
        `${this.entityOrderReturn}/get-by-id/${id}`
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      throw this.errorWrapper(error)
    }
  }

  static async delOrderReturn (param) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderReturn}/cancel-return-order`,
        param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async updateOrderReturn(param) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderReturn}/update-return-order`,
        param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    } 
  }

  static async updateExchangeReturnOrder(param) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderReturn}/update-exchange-return-order`,
        param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async createReturnNotExchange(param) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderReturn}/create-return-order`,
        param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    } 
  }

  static async createReturnHasExchange(param) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderReturn}/create-exchange-return-order`,
        param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    } 
  }

  static async cancelOrderReturn(param) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderReturn}/cancel-return-order`,
        param
      )
      return this.responseWrapper(response, response.data.data)
    } catch (error) {
      throw this.errorWrapper(error)
    }
  }
  
  // handle order from nextshop-web
  static async cancelItemStore(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderStore}/cancel`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async confirmPayment(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderStore}/confirm-payment`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async confirmCheckout(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderStore}/confirm-checkout`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
  
  static async updateOrderCustomer(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderStore}/update-order`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
  
  static async cancelBeforeConfirm(_params) {
    try {
      const response = await this.callApi().post(
        `n360/inte/api/integrate/delivery/cancel-before-confirm`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async deliveryToShipperApi(_params) {
    try {
      const response = await this.callApi().post(
        `n360/inte/api/integrate/delivery/change-dlo-status-to-processing`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async deliveryToPartnerApi(_params) {
    try {
      const response = await this.callApi().post(
        `nsh/odm/api/order/dlo/push-delivery-order`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async updateStatusByMerchant(_params) {
    try {
      const response = await this.callApi().post(
        `n360/inte/api/integrate/delivery/update-status-by-merchant`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async getDloById(dloId) {
    try {
      const response = await this.callApi().get(
        `${this.entityOrderDLO}/get-by-id/${dloId}`,
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async getListDloByIds(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderDLO}/paging-search`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  // thong
  static async getListOrdersDelivery(params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderDelivery}/paging-search`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async getDetailOrderDelivery(id) {
    try {
      const response = await this.callApi().get(
        `${this.entityOrderDelivery}/get-by-id/${id}`
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      throw this.errorWrapper(error)
    }
  }

  static async updateInforDLO(param) {
    try {
      const response = await this.callApi().post(`/n360/inte/api/integrate/delivery/update-info`, param);
      return response.data
    } catch (error) {
      throw this.errorWrapper(error)
    }
  }

  static async cancelDLOBeforeConfirm(param) {
    try {
      const response = await this.callApi().post(`/n360/inte/api/dlo/order/cancel-before-confirm`, param);
      return response.data
    } catch (error) {
      throw this.errorWrapper(error)
    }
  }

  static async updateDeliveryOrderStatus(param) {
    try {
      const response = await this.callApi().post(`/n360/inte/api/dlo/order/update-status-by-merchant`, param);
      return response.data
    } catch (error) {
      throw this.errorWrapper(error)
    }
  }

  static async changeDloStatusToProcessing(id) {
    try {
      const response = await this.callApi().post(`/n360/inte/api/dlo/order/${id}/change-dlo-status-to-processing`);
      return response.data
    } catch (error) {
      throw this.errorWrapper(error)
    }
  }

  static async cancelOrderDelivery(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderDelivery}/cancel`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  // doan
  static async createNewDelivery(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrderDLO}/create`,
        _params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
  static async confirmOrderSOToDLO(_params) {
    try {
      const response = await this.callApi().post(
        `${this.entityOrder}/confirm-delivery-so`,
        _params
      );
      return response.data;
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }

  static async exportData(_params) {
    try {
      const response = await this.callApi().post(
        `nsh/iex/api/order/download-data`,
        _params
      );
      return response.data;
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
  static async exportDataRO(_params) {
    try {
      const response = await this.callApi().post(
        `nsh/iex/api/order/download-data/RO`,
        _params
      );
      return response.data;
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
  static async exportDataROLineItems(_params) {
    try {
      const response = await this.callApi().post(
        `nsh/iex/api/order/download-data/RO/lineItems`,
        _params
      );
      return response.data;
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
  static async exportDataLineItems(_params) {
    try {
      const response = await this.callApi().post(
        `nsh/iex/api/order/download-data/lineItems`,
        _params
      );
      return response.data;
    } catch (error) {
      throw this.errorWrapper(error);
    }
  }
}
